/* eslint-disable jsx-a11y/control-has-associated-label */
import { useState } from 'react';
import SetingsIcon from '../icons/SettingsIcon';
import { appConfig } from '../constants';

export default function Settings() {
  const [minFollowers, setMinFollowers] = useState(appConfig.minFollowers);
  const [pool, setPool] = useState(appConfig.pool);
  const [genre, setGenre] = useState(appConfig.genre);

  const [showing, setShowing] = useState(false);
  function setNewMinFollowers(e) {
    setMinFollowers(e.target.value);
    appConfig.minFollowers = e.target.value;
  }
  function setNewPool(e) {
    setPool(e.target.value);
    appConfig.pool = e.target.value;
  }
  function setNewGenre(e) {
    appConfig.genre = e.target.value;
    setGenre(e.target.value);
  }
  function toggleShowing() {
    setShowing((e) => !e);
  }
  return (
    <div className="absolute top-3 left-3">
      <button type="button" onClick={toggleShowing}><SetingsIcon /></button>
      {showing && (
      <div className="border border-white rounded p-3 mt-3 w-72">
        <p className="text-white font-bold">
          Minimum followers:
          {' '}
          {minFollowers}
        </p>
        <p className="text-white">The minimum number of followers of the 2 artists on Spotify</p>
        <input value={minFollowers} type="range" min="10000" max="10000000" onChange={setNewMinFollowers} step="10000" />
        <p className="text-white font-bold">
          Pool:
          {' '}
          {pool}
        </p>
        <p className="text-white">Set pool to a larger value for a larger selection of artists but lower loading times</p>
        <input value={pool} type="range" min="1" max="5" onChange={setNewPool} />
        <p className="text-white font-bold">
          Genre:
          {' '}
          {pool}
        </p>
        <p className="text-white">Set the genre of the 2 artists. The game works best when a genre is selected</p>
        <select value={genre} onChange={setNewGenre}>
          <option value="all">All</option>
          <option value="rap">Rap</option>
          <option selected value="pop">Pop</option>
          <option selected value="rock">Rock</option>
        </select>
      </div>
      )}
    </div>
  );
}
